import { CatchPraise } from "@/components/catchPraise";
import { useGetSpecial, type SpecialDetailResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Spinner } from "@chakra-ui/react";
import { CustomBox, CustomCenter, CustomDivider, CustomTitle } from "./specialDetail.style";

export const SpecialDetail = ({ specialIdx }: { specialIdx: string }) => {
    const { data } = useGetSpecial<SpecialDetailResponse>({ section: "detail", specialIdx });
    const { isMobile } = MEDIA();

    return data ? (
        <Box position="relative">
            <Center as="section" flexDir="column" rowGap="60px">
                <Center w="100%" justifyContent="space-between">
                    <CustomDivider w={isMobile ? "60px" : "360px"} />
                    <CustomTitle>{data.specialDetailInfo.name.kr}</CustomTitle>
                    <CustomDivider w={isMobile ? "60px" : "360px"} />
                </Center>
                <CustomCenter
                    w="100%"
                    h="640px"
                    boxSizing="border-box"
                    p={isMobile ? "32px 24px" : "96px 48px"}
                    columnGap={isMobile ? "auto" : "24px"}
                    rowGap={isMobile ? "24px" : "auto"}
                    borderRadius="24px"
                    flexDir={isMobile ? "column" : "row"}
                >
                    <Box
                        w="100%"
                        h="100%"
                        background={`url(${data.imgUrl}) no-repeat center/cover`}
                        borderRadius="24px"
                    ></Box>
                    <CustomBox
                        w="100%"
                        h={isMobile ? "auto" : "100%"}
                        flexDir="column"
                        justifyContent="space-between"
                        p={isMobile ? "0" : "32px"}
                        rowGap={isMobile ? "32px" : "auto"}
                    >
                        <CatchPraise catchPraise={data.catchPraise} isDetail={!isMobile ?? true} />
                        {/* <CustomText>
                            Cherish each moment of your journey.
                            {!isMobile &&
                                "Whether its a breathtaking sunset, a heartwarming conversation with locals, or a quiet moment of reflection"}
                            capture these memories to treasure forever.
                        </CustomText> */}
                    </CustomBox>
                </CustomCenter>
            </Center>
        </Box>
    ) : (
        <Spinner />
    );
};
